let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("bYxCZ")).then(() => parcelRequire('jOGxt'));